import React, { memo } from 'react';

const StatusPanel = memo(({ job = null, isCreateMode = false }) => {
  if (isCreateMode) {
    return (
      <div className="bg-white shadow-lg p-4 lg:p-6 mb-4">
        <h3 className="text-lg font-semibold mb-4">Status</h3>
        <div className="text-gray-500">Create a job to view a status</div>
      </div>
    );
  }

  if (!job) return null;

  return (
    <div className="bg-white shadow-lg p-4 lg:p-6 mb-4">
      <h3 className="text-lg font-semibold mb-4">Status</h3>
      <div className="space-y-4">
        <div>
          <div className="text-sm text-gray-600">Job ID</div>
          <div className="font-medium">{job.id}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Status</div>
          <div className={`inline-block px-2 py-1 rounded text-sm font-medium ${
            job.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
            job.status === 'COMPLETED' ? 'bg-green-100 text-green-800' :
            job.status === 'FAILED' ? 'bg-red-100 text-red-800' :
            'bg-gray-100 text-gray-800'
          }`}>
            {job.status}
          </div>
        </div>
        {job.demographics_csv_path && (
          <div>
            <div className="text-sm text-gray-600">Demographics CSV Path</div>
            <div className="font-mono text-sm break-all">{job.demographics_csv_path}</div>
          </div>
        )}
        {job.quality_threshold != null && (
          <div>
            <div className="text-sm text-gray-600">Quality Threshold</div>
            <div className="font-medium">{job.quality_threshold}</div>
          </div>
        )}
        <div>
          <div className="text-sm text-gray-600">Created at</div>
          <div className="font-medium">{new Date(job.created_at).toLocaleString()}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Updated at</div>
          <div className="font-medium">{new Date(job.updated_at).toLocaleString()}</div>
        </div>
        {job.username && (
          <div>
            <div className="text-sm text-gray-600">User</div>
            <div className="font-medium">{job.username}</div>
          </div>
        )}
        {job.gcs_path && (
          <div>
            <div className="text-sm text-gray-600">GCS Path</div>
            <div className="font-mono text-sm break-all">{job.gcs_path}</div>
          </div>
        )}
        {job.signed_url && (
          <div>
            <div className="text-sm text-gray-600">Download</div>
            <a
              href={job.signed_url}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Open Download Link
            </a>
          </div>
        )}
        {job.demographics_output_csv_url && (
          <div>
            <div className="text-sm text-gray-600">Download Demographics with Quality Measures</div>
            <a
              href={job.demographics_output_csv_url}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Open Download Link
            </a>
          </div>
        )}
        {job.error_message && (
          <div>
            <div className="text-sm text-gray-600">Error</div>
            <div className="text-red-600 text-sm">{job.error_message}</div>
          </div>
        )}
      </div>
    </div>
  );
});

StatusPanel.displayName = 'StatusPanel';

export default StatusPanel;
